





































































import Vue, { PropType } from 'vue'
import UiProductBox from '../UiProductBox'
import UiIcon from '../UiIcon'
import { Product, AccessoriesListData } from './UiAccessoriesList.types'
import UiListingPagination from './UiListingPagination/UiListingPagination.vue'

export default Vue.extend({
  name: 'UiAccessoriesList',
  components: {
    UiProductBox,
    UiListingPagination,
    UiIcon
  },
  props: {
    products: {
      type: Array as PropType<Product[]>,
      default: () => []
    },
    filters: {
      type: Array,
      default: () => []
    },
    slug: {
      type: String,
      default: '/'
    },
    categories: {
      type: String,
      default: 'Categories'
    }
  },
  data () {
    return {
      currentPage: 1,
      filteredAccessories: [],
      productsPerPage: 12,
      currentCategory: null,
      filtersVisible: false
    } as AccessoriesListData
  },
  computed: {
    currentAccessories (): Product[] {
      if (this.filteredAccessories.length <= this.productsPerPage) {
        return this.filteredAccessories
      } else {
        const startIndex = this.currentPage * this.productsPerPage - this.productsPerPage
        const endIndex = startIndex + this.productsPerPage
        return this.filteredAccessories.slice(startIndex, endIndex)
      }
    },
    pageCount (): number {
      return Math.ceil(this.filteredAccessories.length / this.productsPerPage)
    }
  },
  created () {
    if (typeof this.$route !== 'undefined') {
      const category = this.$route.query.category
      const page = this.$route.query.page

      if (category && typeof category === 'string') {
        this.setCategory(category)
      } else {
        this.setCategory(null)
      }
      if (page && typeof page === 'string') {
        this.currentPage = parseInt(page)
      }
    } else {
      this.setCategory(null)
    }

    this.filteredAccessories = this.getFilteredAccessories()
  },
  methods: {
    setCategory (category: string | null): void {
      this.currentCategory = category
      this.filteredAccessories = this.getFilteredAccessories()
    },
    setUrl (category: string | null): void {
      if (typeof this.$router === 'undefined') return

      if (category === null) {
        this.$router.push({
          query: {
            ...this.$route.query,
            category: undefined,
            page: undefined
          }
        })
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            category,
            page: undefined
          }
        })
      }
    },
    getFilteredAccessories (): Product[] {
      return this.products.filter((product: Product) => {
        if (!this.currentCategory) {
          return true
        }
        if (!product?.accessoryFor?.includes(this.currentCategory)) {
          return false
        }
        return product
      })
    },
    toggleFilters () {
      this.filtersVisible = !this.filtersVisible
    }
  }
})
